// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"2fb52f6fc68a6e2da04d","303":"9286f27b605961c1e6b8","495":"068cca54ed4a9ad3b45e"}[chunkId] + ".js";
};